import { render, staticRenderFns } from "./TemplateProductVariantsModal.vue?vue&type=template&id=cc1a0324&scoped=true"
import script from "./TemplateProductVariantsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TemplateProductVariantsModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TemplateProductVariantsModal.vue?vue&type=style&index=0&id=cc1a0324&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc1a0324",
  null
  
)

export default component.exports